<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-07 21:20:59
-->
<style lang="scss" scope>
.footer {
	background-color: #ffffff;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 2;
	transition: all 0.4s ease;
	&.on {
		bottom: -70px;
	}
	&-content {
		width: calc(100% - 217px);
		padding: 15px 0;
		p {
			font-size: 12px;
			text-align: center;
			font-weight: 400;
			color: #585858;
			span {
				color: #000;
			}
			em {
				color: #ef6a57;
			}
		}
	}
}
</style>

<template>
	<section :class="['footer', { on: $store.getters.getMeunShow }]">
		<div style="display: flex; align-items: center">
			<div style="width: 217px; background: #ebf1f6; padding: 23px 0"></div>
			<div class="footer-content">
				<p>
					Copyright © Copyright @ 2021-2025 Micro Synaesthesia Limited 版权所有
				</p>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "bottomFooter",
	data() {
		return {};
	},

	methods: {
		/**
		 * 处理下拉菜单事件
		 */
		async handleCommand(command) {
			switch (command) {
				//退出登录
				case "loginOut":
					this.$confirm("是否确认退出登录？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "error",
					})
						.then(async () => {
							// const { data: resData } = await loginOut();

							this.$router.push({
								name: "LOGIN",
							});
						})
						.catch(() => {});
					break;

				//密码修改
				case "passwordEdit":
					this.$router.push({
						name: "SYSTEM_ADMIN_PASSWORD",
					});
					break;
			}
		},
	},
};
</script>
